import { render, staticRenderFns } from "./FAQRequest.vue?vue&type=template&id=88e0bf8a&"
import script from "./FAQRequest.vue?vue&type=script&lang=js&"
export * from "./FAQRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports